import React, { useState } from 'react';
import { Form, Button, Card } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post('/api/auth/forgot-password', { email });
      if (data.success) {
        toast.success('Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <Card>
        <Card.Body>
          <h2 className="auth-title">Şifremi Unuttum</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>E-posta</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="E-posta adresinizi giriniz"
                required
                autoFocus
                autoComplete="off"
              />
            </Form.Group>
            <Button type="submit" variant="primary" className="w-100" disabled={loading}>
              {loading ? 'Gönderiliyor...' : 'Gönder'}
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <div className="text-center mt-3">
        <Link to="/login" className="auth-link">Giriş Yap</Link>
      </div>
    </div>
  );
};

export default ForgotPassword; 